import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './BlogsPage.css';

function BlogsPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Posts' },
    { id: 'safari', name: 'Safari' },
    { id: 'wildlife', name: 'Wildlife' },
    { id: 'travel-tips', name: 'Travel Tips' },
    { id: 'culture', name: 'Culture' },
    { id: 'adventure', name: 'Adventure' }
  ];

  const blogPosts = [
    {
      id: 1,
      title: 'The Great Wildebeest Migration: A Natural Wonder',
      excerpt: 'Witness one of nature\'s most spectacular events as millions of wildebeest, zebras, and gazelles migrate across the Serengeti plains in search of fresh grazing.',
      image: '/assets/imgs/destination/serengeti1.jpg',
      category: 'wildlife',
      author: 'Digital Dream Safaris',
      date: '2024-01-15',
      readTime: '5 min read',
      slug: 'great-wildebeest-migration'
    },
    {
      id: 2,
      title: 'Top 10 Tips for Your First Safari in Tanzania',
      excerpt: 'Planning your first safari? Here are essential tips to make your Tanzanian adventure unforgettable, from what to pack to wildlife viewing etiquette.',
      image: '/assets/imgs/destination/ngorongoro1.jpg',
      category: 'travel-tips',
      author: 'Digital Dream Safaris',
      date: '2024-01-10',
      readTime: '7 min read',
      slug: 'first-safari-tips'
    },
    {
      id: 3,
      title: 'Climbing Mount Kilimanjaro: Everything You Need to Know',
      excerpt: 'Africa\'s highest peak offers an incredible adventure. Learn about the best routes, preparation tips, and what to expect on your journey to the summit.',
      image: '/assets/imgs/destination/Mount-Kilimanjaro.jpg',
      category: 'adventure',
      author: 'Digital Dream Safaris',
      date: '2024-01-05',
      readTime: '10 min read',
      slug: 'climbing-kilimanjaro-guide'
    },
    {
      id: 4,
      title: 'Discovering the Big Five in Ngorongoro Crater',
      excerpt: 'Explore the world\'s largest intact volcanic caldera, home to an incredible density of wildlife including all members of the famous Big Five.',
      image: '/assets/imgs/destination/ngorongoro.webp',
      category: 'safari',
      author: 'Digital Dream Safaris',
      date: '2023-12-28',
      readTime: '6 min read',
      slug: 'big-five-ngorongoro'
    },
    {
      id: 5,
      title: 'Zanzibar: A Tropical Paradise Beyond the Beaches',
      excerpt: 'Beyond pristine beaches, Zanzibar offers rich history, vibrant culture, and incredible diving opportunities. Discover the Spice Island\'s hidden gems.',
      image: '/assets/imgs/destination/zanzibar.jpeg',
      category: 'culture',
      author: 'Digital Dream Safaris',
      date: '2023-12-20',
      readTime: '8 min read',
      slug: 'zanzibar-tropical-paradise'
    },
    {
      id: 6,
      title: 'Tarangire National Park: The Elephant Paradise',
      excerpt: 'Known as the "home of elephants," Tarangire National Park offers incredible elephant viewing and stunning baobab tree landscapes.',
      image: '/assets/imgs/destination/tarangire1.jpg',
      category: 'wildlife',
      author: 'Digital Dream Safaris',
      date: '2023-12-15',
      readTime: '5 min read',
      slug: 'tarangire-elephant-paradise'
    },
    {
      id: 7,
      title: 'Best Time to Visit Tanzania: A Seasonal Guide',
      excerpt: 'Understanding Tanzania\'s seasons is key to planning the perfect trip. Learn when to visit for the best wildlife viewing, weather, and experiences.',
      image: '/assets/imgs/destination/manyara.jpg',
      category: 'travel-tips',
      author: 'Digital Dream Safaris',
      date: '2023-12-10',
      readTime: '6 min read',
      slug: 'best-time-visit-tanzania'
    },
    {
      id: 8,
      title: 'Maasai Culture: Experiencing Traditional Tanzania',
      excerpt: 'Immerse yourself in the rich traditions of the Maasai people, one of Africa\'s most famous ethnic groups, and learn about their way of life.',
      image: '/assets/imgs/maasai.jpg',
      category: 'culture',
      author: 'Digital Dream Safaris',
      date: '2023-12-05',
      readTime: '7 min read',
      slug: 'maasai-culture-experience'
    },
    {
      id: 9,
      title: 'Photography Tips for Safari: Capturing Wildlife Moments',
      excerpt: 'Learn professional techniques for photographing wildlife on safari, from camera settings to composition tips for stunning wildlife shots.',
      image: '/assets/imgs/destination/ruaha.webp',
      category: 'travel-tips',
      author: 'Digital Dream Safaris',
      date: '2023-11-28',
      readTime: '9 min read',
      slug: 'safari-photography-tips'
    }
  ];

  const filteredPosts = selectedCategory === 'all' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="blogs-page">
      {/* Hero Section */}
      <section className="blogs-hero">
        <div className="blogs-hero-content">
          <h1 className="blogs-hero-title">Our Blog</h1>
          <p className="blogs-hero-subtitle">
            Stories, tips, and insights from Tanzania's most beautiful destinations
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="blogs-content">
        <div className="blogs-container">
          {/* Category Filters */}
          <div className="blogs-filters">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`blog-filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Blog Posts Grid */}
          <div className="blogs-grid">
            {filteredPosts.map((post) => (
              <article key={post.id} className="blog-card">
                <Link to={`/blogs/${post.slug}`} className="blog-card-link">
                  <div className="blog-card-image-wrapper">
                    <img 
                      src={post.image} 
                      alt={post.title}
                      className="blog-card-image"
                    />
                    <div className="blog-card-category">
                      {categories.find(cat => cat.id === post.category)?.name || post.category}
                    </div>
                  </div>
                  
                  <div className="blog-card-content">
                    <h2 className="blog-card-title">{post.title}</h2>
                    <p className="blog-card-excerpt">{post.excerpt}</p>
                    
                    <div className="blog-card-meta">
                      <div className="blog-meta-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        <span>{post.author}</span>
                      </div>
                      <div className="blog-meta-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        <span>{formatDate(post.date)}</span>
                      </div>
                      <div className="blog-meta-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        <span>{post.readTime}</span>
                      </div>
                    </div>

                    <div className="blog-card-footer">
                      <span className="blog-read-more">
                        Read More
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M5 12h14M12 5l7 7-7 7"/>
                        </svg>
                      </span>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div className="blogs-empty">
              <p>No blog posts found in this category.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default BlogsPage;

